import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICommonState } from '../../interfaces/state.interfaces';
import { TabKey } from '../../constants/common';

const initialState: ICommonState = {
    resetStoreCounter: 1,
    activeSessionId: null,
    activeTab: TabKey.EDIT,
    isEditorOpen: false,
    isSidebarOpen: true,
    isEditorInFullMode: false,
    loading: {
        changeBrandLoading: false,
        fetchInitialAssetsLoading: false,
        fetchBrandElementsLoading: true,
        campaignsLoading: true,
        sessionsLoading: true,
    },
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        IncreaseResetStoreCounter: (state) => {
            const currentCounter = state.resetStoreCounter;
            state.resetStoreCounter = currentCounter + 1;
        },
        SetActiveSessionId(state, action: PayloadAction<string | null>) {
            state.activeSessionId = action.payload;
        },
        SetActiveTab(state, action: PayloadAction<TabKey | null>) {
            state.activeTab = action.payload;
        },
        SetCommonInitialState(state) {
            state.activeSessionId = null;
            state.isEditorOpen = false;
            state.isSidebarOpen = false;
            state.isEditorInFullMode = false;
            state.loading = {
                changeBrandLoading: false,
                fetchInitialAssetsLoading: false,
                fetchBrandElementsLoading: true,
                campaignsLoading: true,
                sessionsLoading: true,
            };
        },
        SetIsEditorOpen(state, action: PayloadAction<boolean>) {
            state.isEditorOpen = action.payload;
        },
        SetIsSidebarOpen(state, action: PayloadAction<boolean>) {
            state.isSidebarOpen = action.payload;
        },
        SetIsEditorInFullMode(state, action: PayloadAction<boolean>) {
            state.isEditorInFullMode = action.payload;
        },
        ToggleIsEditorOpen(state) {
            state.isEditorOpen = !state.isEditorOpen;
        },
        ToggleIsSidebarOpen(state) {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        ToggleIsEditorInFullMode(state) {
            state.isEditorInFullMode = !state.isEditorInFullMode;
        },
        CLoseFullEditorAndSidebarMode(state) {
            state.isEditorInFullMode = false;
            state.isSidebarOpen = false;
            state.isEditorOpen = false;
        },
        SetChangeBrandLoading(state, action: PayloadAction<boolean>) {
            state.loading.changeBrandLoading = action.payload;
        },
        SetFetchInitialAssetsLoading(state, action: PayloadAction<boolean>) {
            state.loading.fetchInitialAssetsLoading = action.payload;
        },
        SetFetchBrandElementsLoading(state, action: PayloadAction<boolean>) {
            state.loading.fetchBrandElementsLoading = action.payload;
        },
        SetCampaignsLoading(state, action: PayloadAction<boolean>) {
            state.loading.campaignsLoading = action.payload;
        },
        SetSessionsLoading(state, action: PayloadAction<boolean>) {
            state.loading.sessionsLoading = action.payload;
        },
    },
});

export const {
    IncreaseResetStoreCounter,
    SetActiveSessionId,
    SetActiveTab,
    SetCommonInitialState,
    SetIsEditorOpen,
    SetIsSidebarOpen,
    SetIsEditorInFullMode,
    ToggleIsEditorOpen,
    ToggleIsSidebarOpen,
    ToggleIsEditorInFullMode,
    CLoseFullEditorAndSidebarMode,
    SetChangeBrandLoading,
    SetFetchInitialAssetsLoading,
    SetFetchBrandElementsLoading,
    SetCampaignsLoading,
    SetSessionsLoading,
} = commonSlice.actions;

export const commonReducer = commonSlice.reducer;
